import styled from "styled-components";

export const ModalFrame = styled.div`
  width: 500px;
  height: 500px;
  background: white;
`;
